import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithProductGridHealthProvider, useProductGridHealth] = createComponentHealth('ProductGrid');
